var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-x-hidden h-100",attrs:{"id":"app"}},[_c('template-one')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }